import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { configureStore } from "./store";
import ReactGA from "react-ga4";

ReactGA.initialize('G-DZQ03YWS0P'); //Measurement ID
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={configureStore({})}>
    {/* <React.StrictMode> */}
    <BrowserRouter>
      <App />

    </BrowserRouter>
    {/* </React.StrictMode> */}
  </Provider>
);
reportWebVitals();
